import router from '../router/index'
import moment from 'moment';
const state= {
    sorGroup:null,
    sorGroupItems:null,
    sorItems:{
        items:[],
        total:0,
        filter: null
    },
    sorItem:{
        name:null,
        sor_code:null,
        sor_group_id:null,
        sor_group:{
            id:0,
            name:null
        },
        service_category:{
            id:0,
            name:null
        },
        unit_price:null,
        _start_date:null,
        unit_of_measurement:null,
        max_qty:null,
        min_qty:null,
        contract_term_id:null,
        service_category_id:null,
        fault_type:null,
        work_type:null,
        equipment_type:null,
        brand:null,
        model:null,
    },
    sorLoading:{
        group: false,
        item: false,
        create: false,
        import: false,
    },
    treeOption:{
        propertyNames:{
            'text': 'text',
        },
    },
    selectedGroup: null,
    contractId:0,
    Sorvalidate: false
};

const getters = {
    sorGroup : (state) => state.sorGroup,
    sorGroupItems : (state) => state.sorGroupItems,
    sorItems : (state) => state.sorItems,
    sorItem : (state) => state.sorItem,
    sorLoading : (state) => state.sorLoading,
    selectedGroup : (state) => state.selectedGroup,
    treeOption : (state) => state.treeOption,
    contractId : (state) => state.contractId,
    Sorvalidate : (state) => state.Sorvalidate,

};

const actions = {
    async getGroup({commit}, params){
        return new Promise (( resolve, reject ) => {
            let groupRootId = params.sor_group_root_id;
            commit( 'setSorLoadingGroup', true );
            global.axios(`api/sor/group/${groupRootId}`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    commit( 'setSorLoadingGroup', false );
                    commit( 'sorGroupItems', response.data.data.sor_groups );
                    commit( 'setGroup', response.data.data.tree_sor_groups );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async createGroup({commit}, params){
        return new Promise (( resolve, reject ) => {
            let groupRootId = params.sor_group_root_id;
            global.axios(`api/sor/group`, {
                method: "POST",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    //commit( 'setGroup', response.data.data );
                    commit( 'updateItemSorGroupItems', { methodSor: 'create' , data: response.data.data } );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async updateGroup({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/sor/group/${params.id}`, {
                method: "PUT",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
            .then(response => {
                commit( 'updateItemSorGroupItems', { methodSor: 'update' , data: response.data.data } );
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteGroup({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setSorLoadingGroup', true );
            global.axios.delete(`api/sor/group/${params.id}`, {
                data:{
                    sor_group_id: params.sor_group_id
                }
            })
            .then(response => {
                //commit( 'setGroup', response.data.data );
                commit( 'setSorLoadingGroup', false );
                commit( 'deleteItemSorGroupItems', params.id );
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async getItems({commit}, params){
        let page = params[0];
        let limit = params[1];
        let group_id = params[2];
        let filter = params[3];
        return new Promise (( resolve, reject ) => {
            commit( 'setSorLoadingItem', true );
            global.axios.get(`api/sor`, {params:{
                    page:page,
                    group_id:group_id,
                    limit:limit,
                    filter:filter,
                }})
                .then(response => {
                    response.data.data.filter = filter
                    commit( 'setSorLoadingItem', false );
                    commit( 'setItems', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async searchSorCode({commit}, params){
        let page = params[0];
        let limit = params[1];
        let group_id = params[2];
        let filter = params[3];
        let client_contract_id = params[4] ? params[4] : null;
        let supplier_id = params[5] ? params[5] : null;
        let order_id = params[6] ? params[6] : null;
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/sor`, {params:{
                    page:page,
                    group_id:group_id,
                    limit:limit,
                    filter:filter,
                    client_contract_id:client_contract_id,
                    supplier_id:supplier_id,
                    order_id: order_id
                }})
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async saveSorItem({dispatch,commit,state},term_id){
        //Check require data
        commit("setSorvalidate",true);
        let dataSor = state.sorItem;
        dataSor.contract_term_id = term_id;
        dataSor.max_qty = parseInt(dataSor.max_qty);
        dataSor.min_qty = parseInt(dataSor.min_qty);
        dataSor.unit_price = parseFloat(dataSor.unit_price);
        dataSor.effective_date = moment(dataSor._start_date).format("YYYY-MM-DD");
        let status  = moment().diff(moment(dataSor._start_date));
        if(status >= 0){
            dataSor.status = "active";
        }else{
            dataSor.status = "future";
        }
        if(!dataSor.effective_date
            || !dataSor.sor_group_id
            || !dataSor.sor_code
            || !dataSor.name
            || !dataSor.service_category_id
        ){
            router.push({path:"basic-info"});
            return;
        }
        if(!dataSor.unit_price
            || !dataSor.unit_of_measurement
            || !dataSor.max_qty
            || !dataSor.min_qty
        ){
            router.push({path:"pricing"});
            return;
        }
        if((dataSor.max_qty < dataSor.min_qty) || dataSor.max_qty < 0 || dataSor.min_qty < 0){
            router.push({path:"pricing"});
            return;
        }

        //Create new SOR item
        return new Promise (( resolve, reject ) => {
            commit( 'setSorLoadingCreate', true );
            if(dataSor.id){
                global.axios.put(`api/sor/${dataSor.id}`, dataSor)
                    .then(response => {
                        commit( 'setSorLoadingCreate', false );
                        commit( 'setItem');
                        /*if(state.selectedGroup.id === dataSor.sor_group_id){

                        }else{
                            commit( 'setGroupActive',dataSor.sor_group_id);
                        }*/
                        router.push({name:"sor",params:{sorGroupId:dataSor.sor_group_id }});

                        resolve( response );
                    })
                    .catch(error => reject( error ));
            }else{
                global.axios.post(`api/sor`, dataSor)
                    .then(response => {
                        commit( 'setSorLoadingCreate', false );
                        commit( 'setItem');
                        /*if(state.selectedGroup.id === dataSor.sor_group_id){

                        }else{
                            commit( 'setGroupActive',dataSor.sor_group_id);
                        }*/
                        router.push({name:"sor",params:{sorGroupId:dataSor.sor_group_id }});

                        resolve( response );
                    })
                    .catch(error => reject( error ));
            }

        });
    },
    async deleteItem({dispatch,commit,state},params){
        let ids = params;
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/sor`,{
                data:{
                    ids:ids
                }
            })
                .then(response => {
                    //commit( 'setGroup', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });

    },
    async getItem({commit},params){
        let id = params;
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/sor/${id}`,{
            })
                .then(response => {
                    commit( 'setItem', response.data.data );

                })
                .catch(error => reject( error ));
        });

    },
    async UpdateSorItemSupplier({commit},params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/sor/s-contracts/${params.id}`,{
                method: "PUT",
                data : params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });

    },
    importSOR({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('import',params.fileImportSOR);
            commit( 'setSorLoading', {key:'import',val:true} );
            global.axios.post(`api/sor/import/${params.id}`,formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    commit( 'setSorLoading', {key:'import',val:false} );
                    resolve( response );
                })
                .catch(error =>{
                    commit( 'setSorLoading', {key:'import',val:false} );
                    reject( error )
                } );
        });
    }
};

const mutations = {
    setGroup (state,sorGroup) {
        let childrens = []
        if(sorGroup.length){
            sorGroup[0].state = {};
            sorGroup[0].state.selected = true;
            sorGroup[0].state.expanded = true;
            state.selectedGroup = sorGroup[0];
            /*if(!state.selectedGroup){
                sorGroup[0].state = {};
                sorGroup[0].state.selected = true;
                sorGroup[0].state.expanded = true;
                state.selectedGroup = sorGroup[0];
            }else{
                let id = state.selectedGroup.id;
                for (let i in sorGroup) {
                    if(!sorGroup[i].state) sorGroup[i].state = {};
                    sorGroup[i].state = {
                        selected : sorGroup[i].id === id,
                        expanded: true
                    };
                    //temporary solution
                    if(sorGroup[i].children && sorGroup[i].children.length){
                        childrens = childrens.concat(sorGroup[i].children)
                        for (let j in sorGroup[i].children) {
                            sorGroup[i].children[j].state = {
                                selected : sorGroup[i].children[j].id === id,
                                expanded: true
                            };
                        }
                    }
                    //End temporary solution
                }
            }*/
        }else{
            state.sorItems = {
                items:[],
                total:0,
            };
        }

        /*let allCta = {
            children:  sorGroup,
            id:0,
            name:"All group",
            state: { expanded: true , selectable: false,}
        };
        state.sorGroup = allCta;*/
        state.sorGroup = sorGroup;
    },
    sorGroupItems (state, sorGroupItems) {
        state.sorGroupItems = sorGroupItems
    },
    async updateItemSorGroupItems (state, params) {
        if(params.methodSor.includes('create')) {
            state.sorGroupItems.push(params.data)
        }
        else {
            state.sorGroupItems = await state.sorGroupItems.map( item => item.id == params.data.id ? item = Object.assign({}, params.data) : item )
        }
    },
    deleteItemSorGroupItems (state, id) {
        state.sorGroupItems = state.sorGroupItems.filter( item => item.id != id )
    },
    setItems (state,sorItems) {
        state.sorItems.items = sorItems.items;
        state.sorItems.total = sorItems.total;
        state.sorItems.filter = sorItems.filter || null;
    },
    setGroupActive (state,id) {
        for (let i in state.sorGroup.children) {
            if(!state.sorGroup.children[i].state) state.sorGroup.children[i].state = {};
            state.sorGroup.children[i].state = {
                selected : state.sorGroup.children[i].id === id,
                expanded: true
            };
            if(state.sorGroup.children[i].id === id){
                state.selectedGroup = state.sorGroup.children[i];
            }
            //temporary solution
            if(state.sorGroup.children[i].children && state.sorGroup.children[i].children.length){
                for (let j in state.sorGroup.children[i].children) {
                    state.sorGroup.children[i].children[j].state = {
                        selected : state.sorGroup.children[i].children[j].id === id,
                        expanded: true
                    };
                    if(state.sorGroup.children[i].children[j].id === id){
                        state.selectedGroup = state.sorGroup.children[i].children[j];
                    }
                }
            }
            //End temporary solution
        }

    },
    setSelectedGroup (state, selectedGroup) {
        if(state.selectedGroup) {
            state.selectedGroup.state.selected = false;
        }
        state.selectedGroup = selectedGroup;
        if((state.sorGroup[0] && state.sorGroup[0].data.id != selectedGroup.data.id)) {
            state.sorGroup[0].state.selected = false;
        }
        if((state.sorGroup.data && state.sorGroup.data.id != selectedGroup.data.id)) {
            state.sorGroup.state.selected = false;
        }
    },
    setItem (state,sorItem) {
        if(sorItem){
            state.sorItem = sorItem;
            state.sorItem.sor_group = {
                id:sorItem.sor_group.id,
                name:sorItem.sor_group.name
            };
            state.sorItem.service_category = {
                id:sorItem.service_category.id,
                name:sorItem.service_category.name
            };
            let effective_date =  moment(state.sorItem.effective_date,"YYYY-MM-DD").toISOString();
            state.sorItem._start_date = new Date(effective_date);
        }else{
            state.sorItem = {
                name:null,
                sor_code:null,
                sor_group_id:null,
                sor_group:{
                    id:0,
                    name:null
                },
                service_category:{
                    id:0,
                    name:null
                },
                unit_price:0,
                _start_date:null,
                unit_of_measurement:null,
                max_qty:null,
                min_qty:null,
                contract_term_id:null,
                service_category_id:null,
                fault_type:null,
                work_type:null,
                equipment_type:null,
                brand:null,
                model:null,
            }
        }
        state.Sorvalidate = false;
    },
    setSorLoadingGroup (state,val) {
        state.sorLoading.group = val;
    },
    setSorLoadingItem (state,val) {
        state.sorLoading.item = val;
    },
    setSorLoadingCreate (state,val) {
        state.sorLoading.create = val;
    },
    setSorLoading (state,data) {
        state.sorLoading[data.key] = data.val;
    },
    UpdateSorItemGroup (state,data) {
        state.sorItem.sor_group_id = data.id;
        state.sorItem.sor_group.id = data.id;
        state.sorItem.sor_group.name = data.name;
    },
    UpdateSorItemServiceCategory (state,data) {
        state.sorItem.service_category_id = data.id;
        state.sorItem.service_category.id = data.id;
        state.sorItem.service_category.name = data.name;
    },
    setcontractId(state,val){
        state.contractId = val;
    },
    setSorvalidate(state,val){
        state.Sorvalidate = val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
